import {Hardware} from '../types/hardware';
import {Hersteller} from '../types/hersteller';
import { KtostammStandortFieldOk } from "../types/ktostamm-standort";

export interface DisplayableQueryConverter {
  convert(value: string | number | object): string;
  name(keyName: string): string;
}

const KEYS: (keyof Hardware)[] = [
  'arbeitsgruppe',
  'id',
  'ausscheidedatum',
  'autoid',
  'benutzer',
  'betriebssystem',
  'dns1',
  'dns2',
  'domaene',
  'express_service_tag',
  'garantietyp',
  'gateway',
  'hardwaretyp',
  'hersteller',
  'hostname',
  'ip_adresse',
  'ip_dhcp',
  'ip_dhcp_reservierung',
  'ip_statisch',
  'lieferdatum',
  'lizenzkey',
  'mac_adresse',
  'passwort',
  'produkt',
  'service_tag',
  'standort',
  'ktostamm_standort',
  'seriennummer',
  'subnetzmaske',
  'supportbis',
  'supporttyp',
  'teamviewerid',
  'teamviewer_passwort'
];

function createKeyMap(): Record<keyof Hardware, DisplayableQueryConverter> {
  const result: Record<keyof Hardware, DisplayableQueryConverter> = {} as any;

  for (const key of KEYS){
    result[key] = {
      convert(value: unknown): string {
        if (value && typeof value === 'object') {
          return value[key] ?? (value as any)?.bezeichnung ?? '';
        }

        return typeof value === 'string' ? value : `${value}`;
      },
      name(keyName: string): string {
        return keyName.toUpperCase();
      }
    };
  }

  return result;
}

export const HardwarePropertyNameMap = {
  ...createKeyMap(),
  hersteller: {
    convert(value: unknown): string {
      return (value as Hersteller)?.hersteller ?? (value as Hersteller)?.bezeichnung ?? (value as Hersteller)?.gln;
    },
    name(_: string): string {
      return 'Hersteller'.toUpperCase();
    }
  },
  autoid: {
    convert(value: unknown): string {
      return value as string;
    },
    name(_: string): string {
      return 'Id'.toUpperCase();
    }
  },
  ktostamm_standort: {
    convert(value: unknown): string {
      return (value as KtostammStandortFieldOk).subnummer  + ' - ' + (value as KtostammStandortFieldOk)['kurzbez'];
    },
    name(_: string): string {
      return 'Kunde Standort'.toUpperCase();
    }
  }
};
